<template>
  <!-- "Consumer Details" card, same look as the S&R one (nest_consumer_detail): avatar + name, email / phone,
       then View Members (when a members page exists) and the Call pill. Used by the appointment and UQ details. -->
  <div class="shadow-[0px_0px_10px_0px_#0000001A] rounded-[20px] px-[15px] laptop:px-[20px] py-[20px] bg-white font-roboto">
    <div class="flex items-center gap-1 pb-[15px]">
      <div class="w-[8px] h-[8px] rounded-full bg-[#A084E8]" />
      <div class="w-[35px] h-[8px] rounded-full bg-[#A084E8]" />
      <p class="text-[18px] laptop:text-[20px] font-semibold pl-2 m-0 text-[#333333]">Consumer Details</p>
    </div>
    <div :class="['flex items-center gap-[15px]', (membersTo || consumer.phone) && 'pb-[15px] border-b-1 border-[#EFEFEF]']">
      <img v-if="consumer.profile_picture" :src="consumer.profile_picture" alt=""
        class="w-[50px] h-[50px] rounded-full object-cover flex-shrink-0">
      <span v-else class="w-[50px] h-[50px] rounded-full flex items-center justify-center flex-shrink-0 bg-[#EFEFEF]">
        <svg width="30" height="30" viewBox="0 0 16 16" aria-hidden="true">
          <path fill="#CCCCCC" d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm-5 6a5 5 0 0 1 10 0z" />
        </svg>
      </span>
      <div class="min-w-0">
        <p class="m-0 text-[16px] largeDesktop:text-[18px] text-[#333333] break-words">{{ consumer.full_name || '-' }}</p>
        <a v-if="consumer.email" :href="'mailto:' + consumer.email"
          class="block text-[13px] text-[#666666] no-underline break-all">{{ consumer.email }}</a>
        <a v-if="consumer.phone" :href="'tel:' + consumer.phone"
          class="block text-[13px] text-[#666666] no-underline">{{ consumer.phone }}</a>
      </div>
    </div>
    <div v-if="membersTo || consumer.phone" class="flex flex-wrap items-center gap-[10px] pt-[15px]">
      <router-link v-if="membersTo" :to="membersTo"
        class="group flex items-center gap-[6px] h-[36px] px-[15px] rounded-full border-1 border-[#00B7C2] bg-[#fff] text-[14px] text-[#00B7C2] no-underline hover:!bg-[#00B7C2] hover:text-white [@media(max-width:1023px)]:!bg-[#00B7C2] [@media(max-width:1023px)]:!text-white transition">
        View Members
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
          <path d="M4 12h16m0 0-6-6m6 6-6 6" class="stroke-[#00B7C2] group-hover:stroke-white [@media(max-width:1023px)]:!stroke-white"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </router-link>
      <!-- no booking / order here, so Call only -->
      <ChatChooser :size="36" :show-chat="false" :phone="consumer.phone || ''" :consumer-name="consumer.full_name || ''" />
    </div>
  </div>
</template>

<script>
import ChatChooser from "../chat/ChatChooser.vue";

export default {
  components: { ChatChooser },
  props: {
    consumer: { type: Object, default: () => ({}) },
    // members page route ("Members at this Address", same page as S&R); no button when empty
    membersTo: { type: [Object, String], default: null },
  },
};
</script>
